import { render, staticRenderFns } from "./newDetails.vue?vue&type=template&id=07a98858&scoped=true"
import script from "./newDetails.vue?vue&type=script&lang=js"
export * from "./newDetails.vue?vue&type=script&lang=js"
import style0 from "./newDetails.vue?vue&type=style&index=0&id=07a98858&prod&lang=css"
import style1 from "./newDetails.vue?vue&type=style&index=1&id=07a98858&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a98858",
  null
  
)

export default component.exports